import React from 'react';
import PropTypes from 'prop-types';

import Checkbox from 'material-ui/Checkbox';

import cx from 'classnames';
import s from '../FormElement.css';


const PortalCheckbox = ({
  checked, className, description, disabled, id,
  label, labelStyle, name, onChange, onBlur,
}) => {
  return (
    <div className={cx(s.component, className,
        {[`${s.disabled}`]: disabled})}>
      <Checkbox
        checked={checked}
        disabled={disabled}
        id={id}
        title={name}
        label={label}
        labelStyle={labelStyle}
        name={name}
        onCheck={(event, isChecked) => { if (onChange) onChange(event, isChecked) }}
        onBlur={onBlur}
        />

      {description &&
        <label className={s.description}>
          {description}
        </label>}
    </div>
  );
};

PortalCheckbox.propTypes = {
  checked: PropTypes.bool,
  className: PropTypes.string,
  description: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string.isRequired,
  label: PropTypes.node,
  labelStyle: PropTypes.object,
  name: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
};

export default PortalCheckbox;



// WEBPACK FOOTER //
// ./src/components/FormElements/PortalCheckbox/PortalCheckbox.js